import request from '@/utils/request';

export function fetchList(params) {
  return request({
    url: 'v1/digitalProducts/list',
    method: 'get',
    params,
  });
}

export function fetchOptions(params) {
  return request({
    url: 'v1/digitalProducts/listOptions',
    method: 'get',
    params,
  });
}

export function fetchCSV() {
  return request({
    url: '/v1/digitalProducts/SwingBy_Digital_Product.csv',
    method: 'get',
  });
}
